import { DtoTranslatesParser } from "./DtoTranslatesParser";
import { DtoCuisineParser } from "./DtoCuisineParser";
import { TDtoTechnicalRestaurantEntry } from "./__types__/TDtoTechnicalRestaurantEntry";
import { TParseDto } from "../__types__/dto";
import { Utils } from "../..";
import { isString } from "@modules/utils/isString";
import { OrderType } from "@constants/ordering/orderTypes";
import { isNumber } from "lodash";

export const DtoTechnicalRestaurantParser: TParseDto<
  TDtoTechnicalRestaurantEntry
> = (data: any): TDtoTechnicalRestaurantEntry => ({
  allow_order_for_else: Boolean(data.allow_order_for_else),
  applepay_enabled: Boolean(data.applepay_enabled),
  certificate: isString(data.certificate) ? data.certificate : "",
  client_id: Number(data.client_id),
  cuisines: data?.cuisines?.map((item: unknown) => DtoCuisineParser(item)),
  currency: String(data.currency),
  currency_code: String(data.currency_code),
  currency_name: DtoTranslatesParser(data.currency_name),
  description: DtoTranslatesParser(data.description),
  domain: data.domain ?? "",
  hasActiveCashback: Boolean(data?.has_active_cashback),
  id: Number(data.id),
  image: Utils.isString(data.image) ? data.image : "",
  image_md: Utils.isString(data.image_md) ? data.image_md : "",
  img_logo: Utils.isString(data.img_logo) ? data.img_logo : "",
  isCashbackEnabled: Boolean(data?.is_cashback_enabled),
  isWalletEnabled: Boolean(data?.is_wallet_enabled),
  item_notes: Boolean(data.item_notes),
  name: DtoTranslatesParser(data.name),
  order_notes: Boolean(data.order_notes),
  order_type: [
    OrderType.Both,
    OrderType.Delivery,
    OrderType.Pickup,
    OrderType.DineIn,
  ].includes(data.order_type)
    ? data.order_type
    : OrderType.Both,
  status: Boolean(data.status),
  vat: isNumber(data.vat) ? data.vat : 0,
  vat_included: Boolean(data.vat_included),
  vat_registration_number: isString(data.vat_registration_number)
    ? data.vat_registration_number
    : "",
  working_now: Boolean(data.working_now),
});
